import { NetworkService } from "@/services/NetworkService"
import endpoints from "@/infrastructure/http/endpoints"
import { IUserRemoteDataSource } from "../../interfaces/remote/IUserRemoteDataSource"
import { SubscriptionHistoryResponseDTO } from "@/infrastructure/dto/SubscriptionHistoryResponseDTO"
import { ListPrescriptionFeedbackQueryParamsDTO } from "@/domain/dto/ListPrescriptionFeedbackQueryParamsDTO"
import { PrescriptionFeedbackResponseDTO } from "@/infrastructure/dto/PrescriptionFeedbackResponseDTO"

export class UserRemoteDataSource implements IUserRemoteDataSource {
    network
    constructor(ntw: NetworkService) {
        this.network = ntw
    }

    list(userId: string): Promise<SubscriptionHistoryResponseDTO> {
        return this.network.get(`${endpoints.userSubscriptionHistory}/${userId}`)
    }

    listPrescriptionFeedback(params: ListPrescriptionFeedbackQueryParamsDTO): Promise<PrescriptionFeedbackResponseDTO> {
        return this.network.get(endpoints.actionFeedbacks, params)
    }
}
